import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SelectivePreloadStrategy } from './core/strategies/selective-preload.strategy';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { RoleGuard } from './core/guards/role.guard';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuard } from './login/guards/auth.guard';
import { PasswordResetGuard } from './login/guards/password-reset.guard';
import { LoginComponent } from './login/login.component';
import { SsoCallbackComponent } from './login/sso-callback/sso-callback.component';
import { PasswordRecoveryComponent } from './login/password-recovery/password-recovery.component';
import { PasswordResetComponent } from './login/password-reset/password-reset.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: 'login/oauth2/code/company-sso',
    component: SsoCallbackComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },
  {
    path: 'password-recovery',
    component: PasswordRecoveryComponent,
  },
  {
    path: 'password/reset/:username/:passwordResetToken',
    component: PasswordResetComponent,
    canActivate: [PasswordResetGuard],
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        canActivate: [RoleGuard],
        loadChildren: () => import('./components/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'product/:id',
        canActivate: [RoleGuard],
        // Preload in the background so the products area (and its nested lazy cost-comparison
        // route) is ready before the user navigates — see SelectivePreloadStrategy.
        data: { preload: true },
        loadChildren: () => import('./pages/products/overview/product-overview.module').then((m) => m.ProductOverviewModule),
      },
    ],
  },
];

@NgModule({
  // Preload routes flagged with `data: { preload: true }` in the background so the first tab
  // click navigates instantly instead of waiting on an on-demand chunk load.
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: SelectivePreloadStrategy })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
